import React, { useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { useLocation, useHistory } from "react-router-dom";
import { Button } from "@material-ui/core";


let useStyles = makeStyles(() => ({
    root: {
        width: '100%',
        minHeight: '100vh',
    },
    gridLogo: {
        width: 209,
        marginTop: 72,
        margin: 'auto',
        '& > img': {
            width: '100%',
        }
    },
    grid: {
        width: '90%',
        maxWidth: 1198,
        padding: 32,
        borderRadius: 32,
        boxShadow: "0px 2px 15px 0px #0000000D",
        margin: 'auto',
        marginTop: 44,
        backgroundColor: '#ffffff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '75vh',
        textAlign: 'center',
        '@media (max-width: 500px)': {
            width: '98%',
            minHeight: '40vh',
        },
    },
    title: {
        color: '#323232',
        fontWeight: 'bold',
        marginTop: 28,
    },
    customButton: {
        backgroundColor: '#0B1742 !important',
        color: '#fff',
        margin: 'auto !important',
        minWidth: "160px !important",
        minHeight: "40px !important",
    },

}))



const Index = () => {

    let classes = useStyles();
    const location = useLocation();
    const navigate = useHistory();

    const { national_id } = location.state?.state || location.state || {};

    useEffect(() => {
        if (!national_id) {
            redirectNatinalId()
        }
    }, [])

    const redirectNatinalId = () => {
        navigate.push('/register/national', {
            ...location.state
        });
    }

    return (
        <div className={classes['root']}>

            <div className={classes['gridLogo']}>
                <img src="/assets/images/register/logoPouyan.png" alt="" />
            </div>
            <div className={classes['grid']}>
                <div>
                    <img src="/assets/images/register/sejam.png" alt="" />
                    <p className={classes['title']}>
                        بروزرسانی اطلاعات
                    </p>
                    <p>
                        بروزرسانی اطلاعات شما از سجام با موفقیت انجام شد.
                    </p>
                    <div className={classes['gridBtns']}>
                        <Button
                            className={classes.customButton}
                            variant="contained"
                            style={{ color: 'white' }}
                            href="https://pouyanbroker.ir"
                        >
                            بازگشت به وبسایت
                        </Button>
                    </div>
                </div>

            </div>
        </div>

    )
}

export default Index                          